(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["FlowNavigation"] && !Shopify.designMode) return;
  try {
    
function updateMarquee(tags, rightHTML) {
  const tagArray = tags.split(',').map(t => t.trim()).filter(t => t);
  const shuffled = [...tagArray].sort(() => 0.5 - Math.random());

  const blackHTML = shuffled.map(tag => `<span>${tag}</span>`).join(' &nbsp; • &nbsp; ');
  const whiteHTML = shuffled.map(tag => `<span>${tag}</span>`).join('');

  document.getElementById('marquee-black').innerHTML = `
    <div class="marquee-content">${blackHTML}</div>
    <div class="marquee-content">${blackHTML}</div>
  `;
  document.getElementById('marquee-white').innerHTML = `
    <div class="marquee-content">${whiteHTML}</div>
    <div class="marquee-content">${whiteHTML}</div>
  `;

  document.querySelector('.marquee-tab-right').innerHTML = rightHTML;
}


document.querySelectorAll('.tab-button').forEach(btn => {
  btn.addEventListener('click', () => {
    document.querySelectorAll('.tab-button').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');

    const index = btn.dataset.index;

    document.querySelectorAll('.tab-panel').forEach(panel => {
      panel.classList.remove('active');
      if (panel.dataset.index === index) {
        panel.classList.add('active');
        const tags = panel.querySelector('.tab-tags').dataset.tags;
        const rightHTML = panel.querySelector('.tab-right')?.innerHTML || '';
        updateMarquee(tags, rightHTML);
      }
    });
  });
});

// Initial load
document.addEventListener('DOMContentLoaded', () => {
  const panel = document.querySelector('.tab-panel.active');
  const firstTags = panel.querySelector('.tab-tags').dataset.tags;
  const rightHTML = panel.querySelector('.tab-right')?.innerHTML || '';
  updateMarquee(firstTags, rightHTML);
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-scroll-parallax"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const lines = document.querySelectorAll(".scrolling-text-section .text-line");

  window.addEventListener("scroll", () => {
    const scrollTop = window.pageYOffset;
    lines.forEach((line, index) => {
      const direction = index % 2 === 0 ? 1 : -1;
      line.style.transform = `translateX(${scrollTop * 0.1 * direction}px)`;
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["workFlow"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const buttons = document.querySelectorAll('.smart-tabs .tab-btn');
  const contents = document.querySelectorAll('.smart-tabs .tab-content');

  buttons.forEach((button, index) => {
    button.addEventListener('click', function () {
      // Remove active classes
      buttons.forEach(btn => btn.classList.remove('active'));
      contents.forEach(content => content.classList.remove('active'));

      // Add active to current
      this.classList.add('active');
      contents[index].classList.add('active');
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
